import { useAdminSettings } from "./useAdminSettings";

export const useDisplaySettings = () => {
  const { settings } = useAdminSettings();
  
  const layoutMode = settings?.display?.layoutMode || 'adaptive';
  
  return {
    layoutMode,
  };
};